import type {SVGProps} from 'react';

export function Fa7SolidItalic(props: SVGProps<SVGSVGElement>) {
    return (<svg xmlns="http://www.w3.org/2000/svg" width={"1em"} height={"1em"} viewBox="0 0 640 640" {...props}>
        <path fill="currentColor"
              d="M256 128c0-17.7 14.3-32 32-32h192c17.7 0 32 14.3 32 32s-14.3 32-32 32h-58.7L288 480h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32h58.7L352 160h-64c-17.7 0-32-14.3-32-32"></path>
    </svg>);
}